import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { FormService } from '../form.service';
import { BaseControlValueAccessorComponent } from '../inputs/base-control-value-accessor/base-control-value-accessor.component';
import { Option } from '../interfaces/option-interface';

@Component({
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true,
    },
  ],
})
export class CheckboxGroupComponent extends BaseControlValueAccessorComponent implements OnInit {
  @Input() title!: string;
  @Input() options!: Array<Option>;
  @Input() required!: boolean;
  @Input() minChoices: number | undefined;
  @Input() maxChoices: number | undefined;
  @Input() formControl = new UntypedFormControl();

  selectedOptions: string[] = [];

  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    if (this.required) {
      this.title += ' *';
    }
    if (!this.formControl.value) {
      this.formControl.setValue(null);
    } else {
      this.selectedOptions = this.formControl.value;
    }
  }

  selectOption(event: Event, option: Option): void {
    if (this.formControl.disabled) {
      return;
    }
    event.preventDefault();

    if (this.formControl.untouched) {
      this.formControl.markAsTouched();
    }

    const isAlreadySelected = this.selectedOptions.includes(option.id);
    this.selectedOptions = isAlreadySelected
        ? this.selectedOptions.filter((item) => item !== option.id)
        : [...this.selectedOptions, option.id];

    this.formControl.setValue(this.selectedOptions.length > 0 ? this.selectedOptions : null);
  }
}
